import script from "./ProfileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProfileLayout.vue?vue&type=style&index=0&id=b75b6046&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75b6046"]])

export default __exports__